<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          rows: 'minmax(73px, auto) 1fr',
          gap: '0 12px',
        },
        {
          size: 2,
          columns: 'repeat(20, 1fr)',
          gap: '40px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 20 },
          { size: 2, x: 1, width: 5 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.column_one"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-left`"
          />
        </SlideInView>
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 20 },
          { size: 2, x: 6, width: 5 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.column_two"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-middle`"
          />
        </SlideInView>
      </grid-item>
      <grid-item
        :html-tag="`nav`"
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 20 },
          { size: 2, x: 10, width: 5 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.column_three"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-right`"
          />
        </SlideInView>
      </grid-item>
      <grid-item
        :html-tag="`nav`"
        :class="[`${name}__grid-item`]"
        :layout="[
          { size: 1, x: 1, width: 20 },
          { size: 2, x: 15, width: 5 },
        ]"
      >
        <SlideInView
          direction="up"
          slide-distance="100%"
          :threshold="0.1"
          :repeat="false"
          :duration="1"
        >
          <component
            :is="item.component"
            v-for="item in cms.column_four"
            :key="item._uid"
            v-editable="item"
            :cms="item"
            :class="`${name}__content-right`"
          />
        </SlideInView>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'o-x4-column-text',
    }
  },

  computed: {
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#000000',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#FFFFFF'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#FF3476'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
        '--text-align': this.cms.text_align || 'center',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.o-x4-column-text {
  p {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 25px */
  }
}
</style>

<style lang="scss">
.o-x4-column-text {
  p {
    font-size: 20px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: 125% !important; /* 25px */
  }

  h1 {
    color: #161a1d;
    text-align: center;

    /* L - 28/Regular */
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 35px */
  }
  h4 {
    font-family: 'NHaasGroteskTXProRegular', 'Helvetica Neue', Arial, sans-serif !important;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 35px */
    margin-bottom: 20px;
  }
  .a-eyebrow {
    margin-bottom: 10px;
  }

  a {
    font-family: 'NHaasGroteskTXProRegular', 'Helvetica Neue', Arial, sans-serif !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
  }

  li {
    margin-bottom: 0 !important;
    list-style-type: disc !important;
    padding-left: 0 !important;
  }

  li::before {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-x4-column-text {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);
  text-align: var(--text-align);

  ::v-deep .a-cta {
    display: inline-block;
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 22px;
    border: 1px solid #2b353b;
    margin-top: 20px;
    cursor: pointer;
  }

  ::v-deep a,
  ::v-deep .a-cta {
    word-break: break-all;
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
      border: 1px solid var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__grid-item {
    margin-bottom: 50px;
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__content-left,
  &__content-middle,
  &__content-right {
    ::v-deep .a-heading {
      @include font-family($headings-font-family, 600);
      @include font-size(16, 28px);

      margin: 0;
      letter-spacing: 1px;
    }

    ::v-deep .a-copy__text p:last-child {
      margin-bottom: 0;
    }

    ::v-deep .a-copy:last-child p {
      margin-bottom: 0;
    }
  }
}

@include media-breakpoint-up(xl) {
  .o-x4-column-text {
    &__grid-item {
      margin-bottom: initial;
    }
  }
}
</style>
